import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import DataObjectIcon from '@mui/icons-material/DataObject';
import { Chip, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { Severity } from '@/types/validation';

type EventProps = {
  value: any;
  chipText?: string | number;
  onClick: () => void;
  onDelete?: () => void;
  required?: boolean;
  error?: Severity;
};

const EventChip: FC<EventProps> = (props) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='flex-start'
      gap={1}
      width='100%'
      {...(props.error && { color: props.error + '.main' })}
    >
      {props.required && <Typography variant='body1'>*</Typography>}
      <Typography variant='caption'>Event</Typography>
      {!props.chipText && (
        <Typography variant='body1' fontStyle='italic' color='text.disabled'>
          No event set
        </Typography>
      )}
      <Chip
        icon={<DataObjectIcon />}
        deleteIcon={props.chipText ? <CloseIcon fontSize='small' /> : <ArrowDropDownIcon />}
        label={props.chipText || 'Select Event'}
        onDelete={props.onDelete}
        onClick={props.onClick}
        sx={{
          fontFamily: 'monospace',
          fontSize: '1em',
          fontWeight: 700,
          pl: 0.5,
          pr: 0.5
        }}
        size='small'
        color='secondary'
      />
    </Stack>
  );
};

export default EventChip;
